export default function CourseSpecializations({ course }) {
  const specializations = course?.specializations;

  console.log("specializations: ", specializations);
  return (
    <section className="relative overflow-hidden bg-[#F4E8EC] py-20 sm:py-24 lg:py-28">
      {/* Decorative background */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-24 top-10 h-[420px] w-[420px] rounded-full border border-[#8B1E3F]/10"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-10 top-24 h-[290px] w-[290px] rounded-full border border-[#8B1E3F]/10"
      />

      <div className="container relative z-[1] mx-auto">
        <div className="relative">
          {/* Heading */}
          <div className="grid gap-8 border-b border-[#8B1E3F]/20 pb-10 lg:grid-cols-[1.15fr_.85fr] lg:items-end">
            <div>
              <div className="flex items-center gap-3 text-sm font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                <span className="h-px w-10 bg-current" />
                Areas of Specialisation
              </div>

              <h2 className="mt-6 max-w-[850px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(40px,4.8vw,68px)] font-normal leading-[1.05] tracking-[-0.035em] text-[#071A2F]">
                Specializations in{" "}
                <em className="font-normal text-[#8B1E3F]">
                  {course?.shortTitle || course?.title || "this programme"}
                </em>
              </h2>
            </div>

            <p className="max-w-[520px] text-base leading-8 text-[#5F6570] lg:justify-self-end">
              Explore focused academic pathways designed to help you build
              deeper knowledge and capabilities aligned with evolving
              professional opportunities.
            </p>
          </div>

          {/* Specialization rows */}
          <div className="mt-10">
            {specializations.map((item, index) => (
              <article
                key={item.title}
                className="
                group
                relative
                grid
                gap-6
                border-b
                border-[#8B1E3F]/20
                py-5
                transition-all
                duration-300
                md:grid-cols-[90px_1fr_1.15fr_70px]
                md:items-center
                lg:py-7
              "
              >
                {/* Number */}
                <div>
                  <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[38px] font-normal text-[#8B1E3F]/35 transition-colors duration-300 group-hover:text-[#8B1E3F]">
                    {item.number || String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                {/* Title */}
                <div>
                  <span className="mb-3 inline-flex rounded-full border border-[#8B1E3F]/20 bg-white/50 px-4 py-2 text-xs font-bold uppercase tracking-[0.12em] text-[#8B1E3F]">
                    {item.focus || "Specialisation"}
                  </span>

                  <h3 className="max-w-[380px] font-['Libre_Caslon_Display',Georgia,serif] text-[28px] font-normal leading-[1.2] text-[#071A2F] sm:text-[32px]">
                    {item.title}
                  </h3>
                </div>

                {/* Description */}
                <p className="max-w-[500px] text-[15px] leading-7 text-[#626873]">
                  {item.description}
                </p>

                {/* Arrow */}
                <div className="flex md:justify-end">
                  <span
                    className="
                    grid
                    h-12
                    w-12
                    place-items-center
                    rounded-full
                    border
                    border-[#8B1E3F]/20
                    bg-white/60
                    text-lg
                    text-[#8B1E3F]
                    transition-all
                    duration-300
                    group-hover:border-[#8B1E3F]
                    group-hover:bg-[#8B1E3F]
                    group-hover:text-white
                  "
                  >
                    ↗
                  </span>
                </div>

                {/* Hover line */}
                <span className="absolute bottom-[-1px] left-0 h-[2px] w-0 bg-[#8B1E3F] transition-all duration-500 group-hover:w-full" />
              </article>
            ))}
          </div>

          {/* Bottom note */}
          <div className="mt-10 flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
            <p className="max-w-2xl text-sm leading-7 text-[#626873]">
              Specialisation availability may vary according to programme
              structure, academic regulations and the applicable curriculum.
            </p>

            <a
              href="#curriculum"
              className="
              inline-flex
              min-h-[50px]
              items-center
              justify-center
              gap-5
              rounded-full
              bg-[#071A2F]
              px-6
              text-sm
              font-bold
              text-white
              transition
              duration-300
              hover:-translate-y-0.5
              hover:bg-[#8B1E3F]
            "
            >
              View Curriculum
              <span>↗</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}